import { render, staticRenderFns } from "./HomeAgencyUser.vue?vue&type=template&id=13070d10&"
import script from "./HomeAgencyUser.vue?vue&type=script&lang=js&"
export * from "./HomeAgencyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports